// src/pages/buyer/WishlistPage.jsx
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { Heart, ShoppingCart, Trash2, Share2 } from 'lucide-react'
import { wishlistApi, cartApi } from '../../api/services'
import { Button, Card, CardHeader, CardBody, Empty, PageSpinner } from '../../components/common/ui'
import toast from 'react-hot-toast'

export default function WishlistPage() {
  const qc = useQueryClient()
  const { data, isLoading } = useQuery({ queryKey: ['wishlist'], queryFn: () => wishlistApi.index() })
  const remove = useMutation({
    mutationFn: (id) => wishlistApi.toggle({ product_id: id }),
    onSuccess: () => { toast.success('Removed'); qc.invalidateQueries(['wishlist']) },
  })
  const addCart = useMutation({
    mutationFn: (id) => cartApi.add({ product_id: id, quantity: 1 }),
    onSuccess: () => { toast.success('Added to cart'); qc.invalidateQueries(['cart']) },
  })

  if (isLoading) return <PageSpinner />
  const payload = data?.data?.data || data?.data || {}
  const items = payload.items || payload || []
  const itemList = Array.isArray(items) ? items : (items.items || [])

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-xl font-display font-bold flex items-center gap-2"><Heart size={20} className="text-pink" /> Wishlist</h1>
      </div>

      {itemList.length === 0 && (
        <Empty icon="❤️" title="Your wishlist is empty" description="Save fabrics you love to your wishlist."
          action={<Link to="/fabrics"><Button>Browse Fabrics</Button></Link>} />
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {itemList.map(item => {
          const product = item.product || item
          return (
            <Card key={item.id} className="group overflow-hidden">
              <Link to={`/fabrics/${product.slug}`}>
                <div className="aspect-square bg-surface overflow-hidden">
                  <img src={product.primary_image_url || product.image_url} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                </div>
              </Link>
              <CardBody className="p-3">
                <Link to={`/fabrics/${product.slug}`} className="text-sm font-bold text-gray-900 hover:text-pink line-clamp-2">{product.name}</Link>
                <p className="text-sm text-pink font-bold mt-1">₹{Number(product.retail_price || product.price).toLocaleString('en-IN')}/m</p>
                <div className="flex gap-2 mt-2">
                  <Button size="sm" className="flex-1" onClick={() => addCart.mutate(product.id)}>
                    <ShoppingCart size={12} /> Cart
                  </Button>
                  <Button size="sm" variant="ghost" onClick={() => remove.mutate(product.id)}>
                    <Trash2 size={12} />
                  </Button>
                </div>
              </CardBody>
            </Card>
          )
        })}
      </div>
    </div>
  )
}
